'use strict';

/**
 *  @desc 金钱库
 *  @create 2016-10-14
 *  @modify 2016-10-14
 *  @author wangkuan
 */
module.exports = {
    /**
     * 金钱千位分隔符插入函数，create by chentongta。
     *
     * @param  String   value    [以元为单位的一个数值]
     * @return String                      [参照format的格式化结果]
     */
    insertSeparatorMoney: function insertSeparatorMoney(value) {
        var num = value;
        //防止不能转化为数字的输入出现，如100abc这样的。
        if (!num || +num !== +num) {
            return value;
        }

        //将num中的$,去掉，将num变成一个纯粹的数据格式字符串
        num = num.toString().replace(/\$|\,/g, '');

        //如果num是负数，则获取她的符号
        var sign = '';
        if (num.indexOf("-") === 0) {
            sign = '-';
            num = num.slice(1);
        }
        //如果存在小数点，则获取数字的小数部分
        var cents = num.indexOf('.') > 0 ? num.substr(num.indexOf('.')) : '';
        cents = cents.length > 1 ? cents : ''; //注意：这里如果是使用change方法不断的调用，小数是输入不了的
        //获取数字的整数数部分
        num = num.indexOf('.') > 0 ? num.substring(0, num.indexOf('.')) : num;
        //如果没有小数点，整数部分不能以0开头
        if ('' === cents) {
            if (num.length > 1 && '0' == num.substr(0, 1)) {
                return value;
            }
        } else {
            //如果有小数点，且整数的部分的长度大于1，则整数部分不能以0开头
            if (num.length > 1 && '0' === num.substr(0, 1)) {
                return value;
            }
        }
        //针对整数部分进行格式化处理
        //字符串长度大于3的时候，从右往左数，有三位字符就加一个逗号，往前数直到不到往前数少于三位字符为止
        for (var i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++) {
            num = num.substring(0, num.length - (4 * i + 3)) + ',' + num.substring(num.length - (4 * i + 3));
        }
        //将数据（符号、整数部分、小数部分）整体组合返回
        return sign + num + cents;
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@souche-f2e/souche-util/lib/money.js
// module id = bChQ
// module chunks = 11